__turbopack_context__.v({
  "carouselContainer": "coming-soon-module-scss-module__UyLP_a__carouselContainer",
  "comingSoonSection": "coming-soon-module-scss-module__UyLP_a__comingSoonSection",
  "sectionTitle": "coming-soon-module-scss-module__UyLP_a__sectionTitle",
});
